/*
 * File: AlertList.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates and styles the list for each alert type (patient, allergy, account) that the patient has assigned to them. Also styles the Alert Dialog
 */
import React from "react";
import PropTypes from "prop-types";
import { List } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import UIProgress from "components/ui/UIProgress";
import Alerts from "./Alerts";
import { observer } from "mobx-react";
import { useStore } from "utils/useStore";
import AlertStore from "services/patients/alerts/Store";

const styles = theme => ({
  list: {
    padding: 0,
    textAlign: "left",
    color: theme.palette.common.title,
    maxWidth: "100%",
    letterSpacing: theme.spacing(0.2),
    marginTop: theme.spacing(-0.5),
    marginLeft: theme.spacing(-0.25)
  }
});

const PatientAlertList = ({ classes }) => {
  const { alerts, loading } = useStore(AlertStore);
  return (
    <React.Fragment>
      {loading && <UIProgress />}
      {alerts && (
        <List className={classes.list}>
          {alerts.patient.length > 0 && (
            <Alerts
              label="Patient Alerts"
              alerts={alerts.patient}
              type="patient"
            />
          )}
          {alerts.account.length > 0 && (
            <Alerts
              label="Account Alerts"
              alerts={alerts.account}
              type="account"
            />
          )}
          {alerts.allergy.length > 0 && (
            <Alerts
              label="Allergy Alerts"
              alerts={alerts.allergy}
              type="allergy"
            />
          )}
        </List>
      )}
    </React.Fragment>
  );
};

PatientAlertList.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(observer(PatientAlertList));
